import React from 'react';
import './style/Updater.scss';

const Updater = () => {
  return <main id="updater">
    <div>
      <span id="icon" role="img" aria-label="">⚙️</span>
      <p id="message">Updating...</p>
    </div>
  </main>
};

export default Updater;
